<div class="brand" (click)="logoclick()">
    <div
        class="logo curpoint"
        [routerLink]="backLink"
        [queryParams]="backQueryParams"
        tabindex="-1"
        matTooltip="{{ compiledVersion.datetime | date: 'EEE d MMM yyyy HH:mm:ss' }} ({{
            compiledVersion.environment
        }})"></div>

    @if (!mobile) {
        <div class="title">
            <div class="head" [class.print]="print">
                {{ mainTitle }}
            </div>

            @if (!print) {
                <div class="sub" data-testid="page-header-subtitle">
                    {{ subTitle }}
                </div>
            }
        </div>
    }
</div>
